// Тексты слота по умолчанию (русский). Формат подстановок — как у i18next: {{name}}.
// Этот же набор лежит в locales/slot.ru.json — блок "slot" для ru.json фронта; остальные языки фронт переводит сам.
// Где показывается каждая строка — docs/frontend/frontend_slots_kit.md, раздел «Тексты для перевода».
// Все строки выводятся через textContent: HTML в переводах не работает и не нужен.

export default {
  // шапка и панель
  balance: 'Баланс',
  paytable_btn: 'Выплаты',
  bet_per_line: 'Ставка на линию',
  lines: 'Линий',
  total_bet: 'Ставка за спин',
  spin: 'КРУТИТЬ',
  stop: 'СТОП',
  auto: 'АВТО',
  turbo: 'ТУРБО',

  // строка под барабанами
  good_luck: 'Удачи!',
  loading: 'Загрузка…',
  lines_active: 'Активных линий: {{n}} из {{max}}',
  win: 'Выигрыш {{amount}} 💎 · ×{{x}}',
  win_mult: '{{raw}} × {{mult}} = {{amount}} 💎',
  spin_id: 'ID спина: {{id}}',

  // крупный выигрыш (оверлей)
  big_win: 'BIG WIN',
  mega_win: 'MEGA WIN',
  epic_win: 'EPIC WIN',
  x_of_bet: '×{{x}} от ставки',
  tap_to_continue: 'нажмите, чтобы продолжить',

  // бонуска
  bonus_trigger: 'Бонуска!',
  wheel_hint: 'Крутите колесо: от {{min}} до {{max}} фриспинов, множитель ×1, ×2, ×3 …',
  wheel_title: 'КОЛЕСО ФРИСПИНОВ',
  wheel_spin: 'КРУТИТЬ',
  wheel_result: '{{n}} фриспинов · множители {{list}}',
  fs_counter: 'Фриспин',
  fs_total: 'Бонус',
  fs_step: 'Фриспин {{i}} · множитель ×{{mult}}',
  bonus_total_title: 'ИТОГ БОНУСКИ',
  bonus_huge_title: 'ОГРОМНЫЙ БОНУС',
  max_win_reached: 'максимальный выигрыш',
  bonus_result: 'Бонуска: {{amount}} 💎 · ×{{x}}',

  // таблица выплат
  pt_title: 'Выплаты',
  pt_close: 'Закрыть',
  pt_intro: 'Суммы для ставки на линию {{bet}} 💎. Линия платит за 3, 4 или 5 одинаковых символов подряд, начиная с левого барабана.',
  sym_L1: 'Пики',
  sym_L2: 'Трефы',
  sym_L3: 'Бубны',
  sym_L4: 'Червы',
  sym_H1: 'Мишень',
  sym_H2: 'Бомба',
  sym_H3: 'Нож',
  sym_H4: 'Корона',
  pt_special: 'Особые символы',
  pt_wild: 'Wild заменяет любой символ, кроме скаттера. Только на барабанах 2–4.',
  pt_scatter: 'Скаттер считается в любом месте. 3 — ×{{x3}}, 4 — ×{{x4}}, 5 — ×{{x5}} ставки за спин и бонуска.',
  pt_bonus_title: 'Бонуска',
  pt_bonus: 'Три и больше скаттеров запускают колесо фриспинов. Фриспины играются с той же ставкой и линиями, множитель растёт на +1 каждый спин: ×1, ×2, ×3 … до числа фриспинов. Чем больше фриспинов, тем реже выпадает сектор.',
  pt_wheel_row: '{{n}} фриспинов — ×1…×{{n}}',
  pt_max: 'Максимальный выигрыш за раунд (спин вместе с бонуской) — ×{{x}} ставки за спин.',
  pt_lines: 'Линии (активных: {{n}})',

  // плашки и ошибки
  err_no_funds: 'Недостаточно кристаллов — уменьшите ставку или пополните баланс',
  err_login: 'Войдите, чтобы играть',
  err_deposit: 'Слоты доступны после первого пополнения',
  err_disabled: 'Слоты временно недоступны',
  notice_disabling: 'Слоты отключаются: можно доиграть текущий резерв, новую игру не начать',
  err_not_ready: 'Игра запускается, подождите несколько секунд…',
  err_restart: 'Сервер перезапускается, подождите…',
  err_too_fast: 'Слишком часто, подождите секунду',
  err_bet_range: 'Ставка за спин должна быть от {{min}} до {{max}} 💎',
  err_open: 'Не удалось начать игру, попробуйте ещё раз',
  err_session_failed: 'Ошибка игры. Остаток вернётся на баланс автоматически, если нет — напишите в поддержку',
  err_server: 'Спин не сыгран, попробуйте ещё раз',
  err_timeout: 'Нет ответа от сервера, попробуйте ещё раз',
  err_offline: 'Нет соединения, переподключаемся…',
  closed_idle: 'Игра закрыта из-за простоя, {{amount}} 💎 вернулись на баланс',
  closed_shutdown: 'Сервер перезапустился, {{amount}} 💎 вернулись на баланс',
  closed_other: 'Игра закрыта, {{amount}} 💎 вернулись на баланс',
  closed_pending: 'Игра закрыта. Остаток вернётся на баланс в течение 10 минут',
};
